<template>
    <div class="home">
        <div class="content">
            <div class="shop-name">{{ name }}</div>
            <div v-if="loginType === '0'">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="register-ruleForm">
                    <el-form-item prop="phone" class="input-each-div">
                        <el-input class="input-each" v-model="ruleForm.phone" autocomplete="off" placeholder="请输入手机号"
                            maxlength="11" @input="checkLogin"></el-input>
                    </el-form-item>
                    <el-form-item prop="captcha" class="input-each-div">
                        <el-input class="input-each" v-model="ruleForm.captcha" autocomplete="off" placeholder="校验码"
                            maxlength="4"></el-input>
                        <img class="captchaImg" :src="imgsrc" alt="验证码" @click="refreshCaptcha">
                    </el-form-item>
                    <el-form-item prop="code" class="input-each-div">
                        <el-input class="input-each" v-model="ruleForm.code" autocomplete="off" placeholder="验证码"
                            maxlength="4" @input="checkLogin"></el-input>
                        <div class="sendBtn" @click="checkCaptchaImg('ruleForm')">{{ second === totalSecond ?
                            '获取验证码' : second + 's后重新发送' }}</div>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="loginType === '1'">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="register-ruleForm">
                    <el-form-item :prop=item.name class="input-each-div" v-for="(item, value) in loginList"
                        :key="value">
                        <template v-if="item.name === 'name'">
                            <el-input class="input-each" v-model="ruleForm.name" autocomplete="off" placeholder="请输入姓名"
                                @input="checkLogin"></el-input>
                        </template>
                        <template v-if="item.name === 'phone'">
                            <el-input class="input-each" v-model="ruleForm.phone" autocomplete="off"
                                placeholder="请输入手机号" @input="checkLogin"></el-input>
                        </template>
                        <template v-if="item.name === 'idcard'">
                            <el-input class="input-each" v-model="ruleForm.idcard" autocomplete="off"
                                placeholder="请输入身份证号" @input="checkLogin"></el-input>
                        </template>
                        <template v-if="item.name === 'company'">
                            <el-input class="input-each" v-model="ruleForm.company" autocomplete="off"
                                placeholder="请输入工作单位" @input="checkLogin"></el-input>
                        </template>
                        <template v-if="item.name === 'position'">
                            <el-input class="input-each" v-model="ruleForm.position" autocomplete="off"
                                placeholder="请输入职务" @input="checkLogin"></el-input>
                        </template>
                        <template v-if="item.name === 'email'">
                            <el-input class="input-each" v-model="ruleForm.email" autocomplete="off" placeholder="请输入邮箱"
                                @input="checkLogin"></el-input>
                        </template>
                        <template v-if="item.name === 'sno'">
                            <el-input class="input-each" v-model="ruleForm.sno" autocomplete="off" placeholder="请输入学号"
                                @input="checkLogin"></el-input>
                        </template>
                    </el-form-item>
                </el-form>
            </div>
            <div class="all-btn">
                <div class="login-btn" :class="{ 'blue': allowLogin }" @click="submitForm('ruleForm')">登录</div>
                <div v-if="enableReg === '1'" class="register-btn" @click="toRegister()">注册</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getLoginPageInfo, getIdentifyCode, sendMsgCode, loginByCode, login } from '@/api/common'   //路径
export default {
    name: 'LoginPage',
    props: ['id'],
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '' || value.length < 11 || value.substring(0, 1) !== '1') {
                callback(value === '' ? new Error('请输入手机号') : new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
        var validateCaptcha = (rule, value, callback) => {
            if (rule.field === 'captcha' && value === '' && this.checkCaptcha === true && this.loginType === '0') {
                callback(new Error('请输入校验码'));
            } else {
                callback();
            }
        };
        return {
            merchantId: '',
            name: '',
            loginType: '',  // 0:手机验证码登录  1: 自定义登录 
            enableReg: '', // 1:注册入口开启  0: 注册入口关闭
            loginList: [],
            imgsrc: '',
            buttonText: '获取验证码',
            checkCaptcha: false,
            ruleForm: {
                phone: '',
                code: '',
                captcha: '',
                name: '',
                idcard: '',
                company: '',
                position: '',
                email: '',
                sno: '',
            },
            rules: {
                phone: [
                    { validator: validatePhone, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                captcha: [
                    { validator: validateCaptcha, trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                idcard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入工作单位', trigger: 'blur' }
                ],
                position: [
                    { required: true, message: '请输入职务', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' }
                ],
                sno: [
                    { required: true, message: '请输入学号', trigger: 'blur' }
                ],
            },
            totalSecond: 60,//总秒数
            second: 60,//倒计时的秒数
            timer: null, // 定时器 id
            allowLogin: false
        }
    },
    mounted() {
        this.merchantId = this.id;
        let phoneNow = localStorage.getItem('loginPhone');
        if (phoneNow != '' && phoneNow != null) {
            this.ruleForm.phone = phoneNow;
        }
        this.getInfo();
    },
    methods: {
        getInfo() {
            let params = {
                merchantId: this.merchantId,
            }
            getLoginPageInfo(params).then((res) => {
                this.name = res.loginTitle;
                this.enableReg = res.enableReg;
                this.loginType = res.loginType;
                this.loginList = res.merchantCustomLoginList;
                if (res.loginType === '0') {
                    this.getIdentifyCodeImg();
                }
            })
        },
        toRegister() {
            this.$router.push('/register/' + this.merchantId);
        },
        getIdentifyCodeImg() {
            let that = this;
            let params = {};
            getIdentifyCode(params).then((res) => {
                that.imgsrc = 'data:image/png;base64,' + res.imgsrc;
            })
        },
        refreshCaptcha() {
            this.getIdentifyCodeImg();
        },
        checkCaptchaImg(formName) {
            let that = this;
            let flage = true;
            if(that.second < 60) {
                return;
            }
            that.checkCaptcha = true;
            that.$refs[formName].validateField('phone', error => {
                if (error) {
                    flage = false;
                }
            });
            that.$refs[formName].validateField('captcha', error => {
                if (error) {
                    flage = false;
                }
            });
            if (flage) {
                let params = {
                    merchantId: that.merchantId,
                    phone: that.ruleForm.phone,
                    imgCaptcha: that.ruleForm.captcha,
                    type: "1"
                };
                sendMsgCode(params).then((res) => {
                    that.checkCaptcha = false;
                    if (res.code !== 200) {
                        that.getIdentifyCodeImg();
                        that.$message.error(res.msg);
                    } else {
                        that.getCode();
                    }
                })
            } else {
                that.checkCaptcha = false;
            }
        },
        getCode() {
            let that = this;
            if (!that.timer && that.second == that.totalSecond) {
                // 开启倒计时
                that.timer = setInterval(() => {
                    that.second--
                    if (that.second <= 0) {
                        clearInterval(that.timer)
                        that.timer = null // 重置定时器 id
                        that.second = that.totalSecond//归位
                    }
                }, 1000)
                that.$message.success('发送成功,请注意查收')
            }
        },
        checkLogin() {
            // let formName = 'ruleForm';
            if (this.loginType === '0') {
                if (this.ruleForm.phone !== '' && this.ruleForm.code !== '') {
                    this.allowLogin = true;
                } else {
                    this.allowLogin = false;
                }
            } else if (this.loginType === '1') {
                if (this.loginList.length === 0) return;
                let flag = true;
                for (let i = 0; i < this.loginList.length; i++) {
                    let item = this.loginList[i];
                    if (item.name === 'name' && this.ruleForm.name === '') {
                        flag = false;
                        break;
                    }
                    if (item.name === 'phone' && this.ruleForm.phone === '') {
                        flag = false;
                        break;
                    }
                    if (item.name === 'idcard' && this.ruleForm.idcard === '') {
                        flag = false;
                        break;
                    }
                    if (item.name === 'company' && this.ruleForm.company === '') {
                        flag = false;
                        break;
                    }
                    if (item.name === 'position' && this.ruleForm.position === '') {
                        flag = false;
                        break;
                    }
                    if (item.name === 'email' && this.ruleForm.email === '') {
                        flag = false;
                        break;
                    }
                    if (item.name === 'sno' && this.ruleForm.sno === '') {
                        flag = false;
                        break;
                    }
                }
                if (flag) {
                    this.allowLogin = true;
                } else {
                    this.allowLogin = false;
                }
            }
        },
        submitForm(formName) {
            if (this.allowLogin) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.loginType === '0') {
                            this.toLoginByPhone();
                        } else if (this.loginType === '1') {
                            this.toLogin();
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        toLoginByPhone() {
            let that = this;
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            params.merchantId = this.merchantId;
            loginByCode(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    localStorage.setItem('loginPhone', that.ruleForm.phone);
                    localStorage.setItem('loginToken' + this.merchantId, res.token);
                    localStorage.setItem('loginInfo', JSON.stringify(res.student));
                    localStorage.removeItem('examResult');
                    that.$message({
                        duration: 1000,
                        message: '登录成功',//提示的信息
                        type: 'success',//类型是成功
                        onClose: () => {
                            that.$router.push({ path: '/home/' + that.merchantId });
                        }
                    });
                }
            })
        },
        toLogin() {
            let that = this;
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            params.merchantId = this.merchantId;
            login(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    localStorage.setItem('loginPhone', that.ruleForm.phone);
                    localStorage.setItem('loginToken' + this.merchantId, res.token);
                    localStorage.setItem('loginInfo', JSON.stringify(res.student));
                    localStorage.removeItem('examResult');
                    that.$message({
                        duration: 1000,
                        message: '登录成功',//提示的信息
                        type: 'success',//类型是成功
                        onClose: () => {
                            that.$router.push({ path: '/home/' + that.merchantId });
                        }
                    });
                }
            })
        }
    },
    unmounted() {
        clearInterval(this.timer);
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
    padding: 32px 40px;
}

.shop-name {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    text-align: left;
    font-weight: 500;
}

.input-each-div {
    position: relative;
    display: flex;
    margin-bottom: 15px;
}

.input-each-div:first-child {
    margin-top: 0px;
}

.input-each-div :deep(.el-input__inner) {
    padding: 0;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #E5E5E5;
}

.input-each {
    flex: 1;
    line-height: 20px;
    outline: none;
}

.input-each::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 500;
}

.all-btn {
    margin-top: 30px;
    overflow: hidden;
}

.login-btn {
    margin-bottom: 20px;
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #CCCCCC;
    border-radius: 32px;
}


.login-btn.blue {
    background: #0095D9;
}

.register-btn {
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #0095D9;
    border-radius: 32px;
}

.captchaImg {
    position: absolute;
    width: 70px;
    height: 30px;
    right: 0;
    top: 50%;
    margin-top: -15px;
}

.sendBtn {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -12px;
    min-width: 70px;
    height: 22px;
    line-height: 22px;
    border: 1px solid #666666;
    border-radius: 12px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #666666;
    letter-spacing: 0;
}
</style>